// extracted by mini-css-extract-plugin
module.exports = {"hnui-tabs-trigger":"Tabs_hnui-tabs-trigger__zrI2Q","hnui-tabs-list":"Tabs_hnui-tabs-list__bdQR7"};